/**
 * ImportButton.js
 * description: Renders button import button and imports a valid LOLcode file
 */
import { useContext } from "react";

import { Button } from "@chakra-ui/react";
import { css } from "@emotion/react";

import { context } from "../context/GlobalState";

const ImportButton = () => {
  const { dispatch } = useContext(context);
  let fileReader;

  // file = e.target.files[0]
  const handleFileChosen = (file) => {
    // If file does not end with either ".lol" or ".lols"
    if (
      file &&
      file.name.slice(-4) !== ".lol" &&
      file.name.slice(-5) !== ".lols"
    ) {
      // Propmts a browser alert
      alert("Invalid LOLCode File");
    } else {
      // If file ends with either ".lol" or ".lols"
      fileReader = new FileReader(); // initialize a file reader, just like f = open("file.txt", "r") in python
      fileReader.onloadend = handleFileRead; // if the file is ready to be read, call handleFileRead
      fileReader.readAsText(file); // reads the file as in text format
      dispatch({ type: "SET_FILENAME", payload: file.name });
    }
  };

  const handleFileRead = (e) => {
    const content = fileReader.result;
    dispatch({ type: "SET_EDITOR_CODE", payload: content });
  };

  return (
    <Button
      css={css`
        :hover {
          color: #172b3a;
          background-color: #fff;
          border-color: #172b3a;
        }
      `}
      mr={5}
      bg="#172b3a"
      border="1px"
      borderColor="white"
    >
      <label style={{ cursor: "pointer" }}>
        <input
          type="file"
          onChange={(e) => {
            handleFileChosen(e.target.files[0]); // if a file is selected after the Choose File prompt call handleFileChose and pass e.target.files[0]
            e.target.value = null; //clear input after every read
          }}
          style={{ display: "none" }}
        />
        IMPORT
      </label>
    </Button>
  );
};

export default ImportButton;
